export const RECESS_COMMUNITY = 'https://about.recess.tv/community/';
export const SUPPORT_ARTICLE = 'https://recesstv.zendesk.com/hc/en-gb/articles/9603592177815';
